// extracted by mini-css-extract-plugin
export default {"list":"TextListSpacer_list__XstXx","item":"TextListSpacer_item__1kzo7"};